// DEV-ONLY read diagnostics. Records ONLY metadata about GET responses —
// never values (no emails, names, messages, tokens, image URLs). Gated by
// NODE_ENV so it stays out of production behavior/builds.
const listeners = new Set();
export const diagStore = { records: [] };
export const subscribeDiag = (cb) => { listeners.add(cb); return () => listeners.delete(cb); };
const emit = () => listeners.forEach((cb) => cb(diagStore.records));

const keysOf = (v) => (v && typeof v === "object" && !Array.isArray(v) ? Object.keys(v) : []);
const nullKeysOf = (v) => (v && typeof v === "object" && !Array.isArray(v)
  ? Object.keys(v).filter((k) => v[k] === null || v[k] === undefined) : []);

export function recordDiag(url, status, data) {
  const rootType = Array.isArray(data) ? "Array" : (data && typeof data === "object" ? "Object" : typeof data);
  const rootKeys = rootType === "Object" ? Object.keys(data) : [];
  const counts = {};
  let sample = null;
  if (Array.isArray(data)) { counts["(root)"] = data.length; sample = data[0] || null; }
  else if (rootType === "Object") {
    for (const k of rootKeys) {
      if (Array.isArray(data[k])) { counts[k] = data[k].length; if (!sample && data[k].length) sample = data[k][0]; }
    }
    if (!sample) sample = data;
  }
  const rec = {
    ts: Date.now(),
    url: (url || "").split("?")[0] + (url && url.includes("?") ? "?" + url.split("?")[1].replace(/=[^&]*/g, "=…") : ""),
    status,
    rootType,
    rootKeys,
    counts,
    sampleFields: keysOf(sample),
    nullFields: nullKeysOf(sample),
  };
  diagStore.records = [rec, ...diagStore.records.filter((r) => r.url !== rec.url)].slice(0, 50);
  emit();
}
